import { render, staticRenderFns } from "./MerchantsTable.vue?vue&type=template&id=c75539fc&scoped=true&"
import script from "./MerchantsTable.vue?vue&type=script&lang=js&"
export * from "./MerchantsTable.vue?vue&type=script&lang=js&"
import style0 from "./MerchantsTable.vue?vue&type=style&index=0&id=c75539fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75539fc",
  null
  
)

export default component.exports